import { HttpClient } from "@angular/common/http";
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { FormControl, NG_VALUE_ACCESSOR, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgSelectComponent } from "@ng-select/ng-select";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { map, takeUntil, tap } from "rxjs/operators";
import { DashboardService } from "src/app/modules/dashboard/services/dashboard.service";
import { TranslationModuleEnum } from "src/app/utils/translation-modules.enum";

@Component({
  selector: "app-scrollable-select",
  templateUrl: "./scrollable-select.component.html",
  styleUrls: ["./scrollable-select.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ScrollableSelectComponent,
      multi: true,
    },
  ],
})
export class ScrollableSelectComponent implements OnInit, OnDestroy, OnChanges {
  // TODO: refactor this component and make it reusable and test scroll load when BE returns more items.
  translationModulesEnum = TranslationModuleEnum;

  @Input() bindValue: any = "id";
  @Input() bindLabel: any = "name";
  @Input() placeholder: string = "";
  @Input() noItemsText: string = "shared.noItemsFound";
  @Input() control: FormControl | undefined;
  @Input() dropdownPosition: "bottom" | "top" | "auto" = "auto";
  @Input() disabled: boolean = false;
  @Input() clearable: boolean = false;
  @Input() compareWith: () => boolean = null;
  @Input() search: boolean = true;
  @Input() title: string = "";
  @Input() multiple: boolean = false;
  @Input() isSubmitted: boolean = false;
  @Input() showValidations: boolean = true;

  @Input() value: any;
  @Input() onDrop: boolean = true;

  @Input() set loading(value: boolean) {
    this.loadingValue = value;
  }

  @Input() set items(value: any) {
    if (value && Array.isArray(value)) this.itemsList = value;
  }

  @Input() labelTranslationKey: string;
  @Input() labelTranslationModuleEnum: number;
  @Input() placeholderTranslationKey: string;
  @Input() placeholderTranslationModuleEnum: number;
  @Input() resetSelectionTrigger: boolean;

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes["resetSelectionTrigger"] &&
      changes["resetSelectionTrigger"].currentValue
    ) {
      this.resetDropdown();
      this.resetSelectionTrigger = !this.resetSelectionTrigger;
    }
    if (this.value) this.initValue = this.value;
  }

  @Output() change = new EventEmitter();
  @Output() onFocus = new EventEmitter();
  @Output() onSearch: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild("select") select: NgSelectComponent;

  private onChange_ = (value: string) => {};
  private onTouched = () => {};
  initValue: any;
  itemsList: any[] = [];
  loadingValue: boolean = false;
  pressReleaseId: string = null;
  lang: string;
  private endSub$ = new Subject();

  constructor(
    private translateSer: TranslateService,
    private route: ActivatedRoute,
    private dashboardService: DashboardService
  ) {}

  ngOnInit(): void {
    this.lang = this.translateSer.currentLang;
    this.checkLangChange();
    this.route.params.subscribe(params => {
      if (params["id"]) {
        this.pressReleaseId = params["id"];
      }
    });
    if (this.value) {
      this.initValue = this.value;
    }
    this.loadMore();
  }

  get isRequired() {
    return this.control?.hasValidator(Validators.required);
  }

  private checkLangChange() {
    this.translateSer.onLangChange
      .pipe(takeUntil(this.endSub$))
      .subscribe(language => {
        this.lang = language.lang;
        this.itemsList = [...this.itemsList];
      });
  }

  private resetDropdown() {
    this.initValue = null;
    this.onChange_(this.initValue);
    this.selectedValueChanged();
    // if (this.select) {
    //   this.select.clear();
    // }
  }

  private selectedValueChanged() {
    this.change.emit(this.initValue);
  }
  writeValue(obj: any): void {
    this.initValue = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange_ = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  changeValue(event) {
    this.onChange_(event);
  }

  focus() {
    this.onTouched();
  }

  _onfocus() {
    this.onFocus.emit();
  }

  clearHandler(evt: any) {
    this.change.emit(this.initValue);
  }

  searchValue(value) {
    if (value && value.term.trim()) this.onSearch.emit(value.term.trim());
  }

  ngOnDestroy(): void {
    this.endSub$.next(null);
    this.endSub$.complete();
  }

  // new scroll dropdown
  @Input() listOfSelectedValue: [];
  randomUserUrl = "https://api.randomuser.me/?results=10";
  listOfOption: string[] = [];
  isLoading = false;
  keywords: string = "";
  @Input() maxLength: number = 0;

  getRandomJobs(pageSize: number = 10, keywords: string = "") {
    return this.dashboardService.getPressReleaseList(pageSize, keywords).pipe(
      tap(x => console.log("data", x)),
      map((list: any[]) =>
        list.filter((item: any) => {
          if (item.id !== +this.pressReleaseId) return item;
        })
      ) // Extract the `name` property from each item
    );
  }

  loadMore(): void {
    this.isLoading = true;
    this.getRandomJobs(999, this.keywords).subscribe(
      (data: string[]) => {
        this.isLoading = false;
        this.listOfOption = [...this.listOfOption, ...data]; // Append new data to the existing list
      },
      error => {
        this.isLoading = false;
        console.error("Error loading more jobs:", error);
      }
    );
  }
}
